export default __webpack_public_path__ + "static/media/YanoneKaffeesatz-SemiBold.0fbeef7a.ttf";